<div *ngIf ="nDataPts > 0" style="display: flex; width: 100%; height: 100%;">
  <div class="analyst-chart-container">
    <canvas id="analystChart"></canvas>
  </div>
  <div class="analyst-chart-container analyst-chart-container-second">
    <canvas id="analystChart2"></canvas>
  </div>
</div>

